var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-placeholder hero is-medium is-light is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }